<template>
  <div id="top">
    <call />
    <pop-alert></pop-alert>
    <header>
      <!-- header -->
      <header-app
        :rate="counterBlock"
        :canMobileOrder="isMobileOrderEnabled(true)"
        v-show="!loading"
      ></header-app>
      <!--menu-->
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <!-- nav bot -->
      <footer-app page="top" :loading="loading"></footer-app>
      <section :class="{ 'fade-base': true, fade: pageFade }" v-show="!loading">
        <!-- list store -->
        <div class="c-list-store c-list-store-no-padding">
          <div class="swiper-container js-sc-news-swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="item in shopNews" :key="item.id">
                <div class="c-box-bell mt-8">
                  <img src="/assets/images/icon/icon-info.svg" alt="" />
                  <router-link :to="`/announce/list?id=${item.id}`" class="c-box-bell__link">
                    <span>{{ item.title }}</span>
                    <svg width="11" height="12">
                      <use xlink:href="#ic-Icon-double-arrow" />
                    </svg>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section :class="{ 'fade-base mb-12': true, fade: pageFade }" v-show="!loading">
        <div class="c-list-deal swiper-container js-banner-swiper" v-show="mainBanners.length > 0">
          <div class="swiper-wrapper">
            <div
              v-for="(banner, index) in mainBanners" :key="banner.id + index"
              class="swiper-slide c-list-deal__item--wrap main-banner__item js-keep-ratio"
              data-ratio="1"
            >
               <img v-if="banner.image" :src="IMG_HOST + banner.image" :alt="banner.title" width="100%" height="100%">
               <img v-else src="/assets/images/aeontown-noimg.png" :alt="banner.title" width="100%" height="100%">
            </div>
          </div>
        </div>
        <div class="swiper-pagination swiper-pagination-banner" v-show="mainBanners.length > 1"></div>
      </section>
      <!-- list deal -->
      <section :class="{ 'fade-base top-content': true, fade: pageFade }" v-show="!loading">
        <div class="l-deal-and-shop pt-0">
          <div class="l-deal-and-shop__title d-flex">
            <div class="font-size-16">ショップニュース</div>
            <div class="l-deal_view-all" @click.self="$router.push('/news')">
              すべてを見る
              <img src="/assets/images/icon/arrow-right.svg" alt="" width="10" height="10">
            </div>
          </div>
          <div class="c-list-deal__item" v-if="newsList.length == 0">
            ただいま掲載中の情報はありません
          </div>
          <div class="c-list-deal swiper-container js-sc-shopnews-swiper" v-show="newsList.length > 0">
            <div class="swiper-wrapper">
              <div
                v-for="(news, index) in newsList"
                :key="news.id + index"
                class="swiper-slide c-list-deal__item--wrap"
              >
                <div class="c-list-deal__item">
                  <div v-on:click="openModalNewsDetail(news)" class="c-list-deal__img js-keep-ratio" data-ratio="0.746">
                    <img v-lazy="getImgSrc(news.image && news.image[0])" alt="" />
                  </div>
                  <div class="c-list-deal__info">
                    <div @click.prevent="shopTop(news.provider)" class="c-news__shop">
                      <div v-if="news.provider && news.provider.id" class="c-news__shop--name">
                        <span>{{ news.provider.shopName }}</span>
                      </div>
                      <div v-else class="c-news__shop--name">
                        <span>{{ news.provider && news.provider.name }}</span>
                      </div>
                    </div>
                    <div
                      @click.self="openModalNewsDetail(news)"
                      class="c-list-deal__info--content c-list-deal__info--title line-clamp-hack c-list-deal__info--title--shop"
                    >
                      <div class="font-bold" v-html="news.title"></div>
                      <favorite-icon
                        :isActive="favoriteNewsExists(news.id)"
                        :toggleFavorite="() => toggleFavoriteNews(news)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination swiper-pagination-news" v-show="newsList.length > 2"></div>
        </div>
        <div class="l-deal-and-shop pt-12">
          <div class="l-deal-and-shop__title d-flex">
            <div class="font-size-16">イベント</div>
            <div class="l-deal_view-all" @click.self="$router.push('/events')">
              すべてを見る
              <img src="/assets/images/icon/arrow-right.svg" alt="" width="10" height="10">
            </div>
          </div>
          <div class="c-list-deal__item" v-if="eventList.length == 0">
            ただいま掲載中の情報はありません
          </div>
          <div class="c-list-deal swiper-container js-sc-shopevents-swiper" v-show="eventList.length > 0">
            <div class="swiper-wrapper">
              <div
                v-for="(event, index) in eventList"
                :key="event.id + index"
                class="swiper-slide c-list-deal__item--wrap"
              >
                <div class="c-list-deal__item">
                  <div
                    v-on:click="openModalDetail(event)"
                    class="c-list-deal__img js-keep-ratio"
                    data-ratio="0.746"
                  >
                    <img v-lazy="getImgSrc(event.image && event.image[0])" alt="" />
                  </div>
                  <div class="c-list-deal__info">
                    <div @click.prevent="shopTop(event.provider)" class="c-news__shop">
                      <div v-if="event.provider && event.provider.id" class="c-news__shop--name">
                        <span class="c-tag--number" v-if="event.provider && event.provider.floorGuideNo">{{ truncatedShopName(event.provider && event.provider.floorGuideNo, 3) }}</span>
                        <span>{{ event.provider.shopName }}</span>
                      </div>
                      <div v-else class="c-news__shop--name">
                        <span>{{ event.provider && event.provider.name }}</span>
                      </div>
                    </div>
                    <div class="event-title">{{ event.title }}</div>
                    <div
                      @click.self="openModalDetail(event)"
                      class="c-list-deal__info--content c-list-deal__info--title line-clamp-hack c-list-deal__info--title--shop"
                    >
                      <div class="c-list-event__time">
                        <span v-html="formatEventTerm2(event)"></span>
                        <br/>
                        {{ event.provider && event.provider.location }}
                      </div>
                      <favorite-icon
                        :isActive="favoriteEventExists(event.id)"
                        :toggleFavorite="() => toggleFavoriteEvent(event)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination swiper-pagination-shopevents" v-show="eventList.length > 2"></div>
        </div>
        <div class="list-banner">
          <div class="js-keep-ratio" data-ratio="0.5329" @click="openBannerLink(banner.url)" v-for="(banner, index) in banners" :key="index">
            <img loading="lazy" :src="getImgSrc(banner.image)" :alt="banner.title" :key="index" />
          </div>
        </div>
        <alert
          :message="alert_msg"
          :show="alert_show"
          :closeModal="closeModal"
          :confirm_show="confirm_show"
          :confirm_message="confirm_msg"
          :confirm_callback="confirm_callback"
          :confirm_hide_cancel="confirm_hide_cancel"
          :label_cancel="confirm_label_cancel"
          :label_ok="confirm_label_ok"
        ></alert>
        <modal :open="openModal" @close="() => {
          openModal = false;
          this.$router.push({ query: {} });
        }">
          <event-detail :eventId="eventId" :eventProviderId="eventProviderId" :toggleFavoriteEvent="(e) => toggleFavoriteEvent(e)" :isActive="favoriteEventExists" @navigateBack="() => this.navigateBack(false)" />
        </modal>
        <modal :open="openModalNew" @close="() => {
          openModalNew = false;
          this.$router.push({ query: {} });
        }">
          <news-detail :newsId="newsId" :newsProviderId="newsProviderId" :toggleFavoriteNews="(e) => toggleFavoriteNews(e)" :isActive="favoriteNewsExists" @navigateBack="() => this.navigateBack(false)" />
        </modal>
        <!-- modal show required login -->
        <modal_login_required></modal_login_required>
      </section>
      <loader :loading="loading" />
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import Alert from "../components/Alert.vue";
import ModalLoginRequired from "../components/ModalLoginRequired.vue";
import MenuApp from "../components/Menu.vue";
import Swiper, { Autoplay } from "swiper";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { NEW_COLLECTION_KEY, EVENT_COLLECTION_KEY, IMG_HOST } from "../config/const.js";
import {
  getDetailCollection,
  getLocalNewsListOfAllProvider,
  getServerNewsListOfAllProvider,
  getSCNews,
  getLocalAllEvents,
  getServerAllEvents,
  getUser,
  updateUserFirstStartupTime,
  updateUserLastStartupTime,
  getSideBanners,
  getMainBanners,
} from "../store/firestore.js";
import PopAlert from "../components/PopAlert.vue";
import store from "../store";
import FavoriteIcon from "../components/FavoriteIcon.vue";
import Modal from "../components/Modal.vue";
import EventDetail from "./EventDetail.vue";
import NewsDetail from "./NewsDetail.vue";
import loader from "../components/parts/loader.vue";

Swiper.use(Autoplay);

export default Vue.extend({
  name: "Top",
  components: {
    "footer-app": Footer,
    "header-app": Header,
    modal_login_required: ModalLoginRequired,
    "menu-app": MenuApp,
    "pop-alert": PopAlert,
    Alert,
    FavoriteIcon,
    Modal,
    EventDetail,
    NewsDetail,
    loader,
  },
  mixins: [Tenant],
  data() {
    return {
      newsList: [],
      eventList: [],
      banners: [],
      mainBanners: [],
      loader: false,
      observer: null,
      newsSize: 5,
      getDetailCollection: getDetailCollection,
      loading: false,
      NEW_COLLECTION_KEY: NEW_COLLECTION_KEY,
      EVENT_COLLECTION_KEY: EVENT_COLLECTION_KEY,
      shopNews: null,
      getSCNews: getSCNews,
      openModal: false,
      eventId: "",
      eventProviderId: "",
      openModalNew: false,
      newsId: "",
      newsProviderId: "",
      IMG_HOST: IMG_HOST,
    };
  },
  watch: {
    '$route.query': {
      handler: function (newVal) {
        if (!newVal.eventId) {
          this.openModal = false
        }
        if (!newVal.newsId) {
          this.openModalNew = false
        }
      },
      immediate: true
    }
  },
  created() {
    if (!store.state.shopId) {
      this.$router.push("/storeselect");
    }
    this.init();
  },
  updated() {
    this.$nextTick(function () {
      Common.setKeepRatio();
    });
  },
  async mounted() {
    new Swiper(".js-sc-news-swiper", {
      slidesPerView: 1,
      observer: true,
      loop: true,
      observeParents: true,
      waitForTransition: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
    });

    Common.initDom();
    Common.analyticsLogEvent("show_top", {
      shopId: this.SHOP_ID,
    });
  },
  methods: {
    async init() {
      this.loading = true;
      Common.vueInitFunc(this);
      const user = await getUser(this.$store.state.userId);
      if (!user.firstStartupTime) {
        await updateUserFirstStartupTime(this.$store.state.userId);
      }
      await Promise.all([updateUserLastStartupTime(this.$store.state.userId),this.getDataShop(), this.getDataNews(), this.getDataEvent(), getSideBanners(store.state.shopId), getMainBanners(store.state.shopId)])
      .then(([updateUser, dataShop, dataNews, dataEvent, banners, mainBanners]) => {
        this.banners = banners;
        this.mainBanners = mainBanners;
      });

      this.loading = false;
      const sefl = this;
      this.$nextTick(() => {
        new Swiper(".js-banner-swiper", {
          slidesPerView: 2,
          loop: sefl.mainBanners.length > 1,
          centeredSlides: true,
          observer: true,
          observeParents: true,
          pagination: {
            el: ".swiper-pagination-banner",
            clickable: true,
          },
          watchSlidesProgress: false,
          on: {
            click: function (item, event) {
              if (sefl.mainBanners?.length === 1) {
                sefl.openMainBannerLink(sefl.mainBanners[0]);
                return;
              }
              if (event.type === 'touchend' && this.clickedSlide) {
                const index = this.clickedSlide.getAttribute("data-swiper-slide-index");
                sefl.openMainBannerLink(sefl.mainBanners[index]);
              }
            },
            slideChange: function () {
              Common.setKeepRatio();
            }
          }
        });
        const newsSlide = new Swiper(".js-sc-shopnews-swiper", {
          slidesPerView: 2.2,
          observer: true,
          observeParents: true,
          pagination: {
            el: ".swiper-pagination-news",
            clickable: true,
            renderBullet: function (index, className) {
              this.slideTo(1, 0, false);
              if (index < 1 || index > sefl.newsList.length - 4) {
                return `<span class="${className} d-none"></span>`;
              }
              return `<span class="${className}"></span>`;
            },
          },
          on: {
            slideChange: function () {
              if (this.realIndex === 0) {
                this.slideTo(sefl.newsList.length - 4, 0 ,false);
              }
              if (this.realIndex === sefl.newsList.length - 3) {
                this.slideTo(1, 0 ,false);
              }
              Common.setKeepRatio();
            },
            observerUpdate: function () {
              Common.setKeepRatio();
            }
          }
        });
        newsSlide.slideTo(1, 0, false);
        const eventSlide = new Swiper(".js-sc-shopevents-swiper", {
          slidesPerView: 2.2,
          observer: true,
          observeParents: true,
          pagination: {
            el: ".swiper-pagination-shopevents",
            clickable: true,
            renderBullet: function (index, className) {
              this.slideTo(1, 0, false);
              if (index < 1 || index > sefl.eventList.length - 4) {
                return `<span class="${className} d-none"></span>`;
              }
              return `<span class="${className}"></span>`;
            },
          },
          on: {
            slideChange: function () {
              if (this.realIndex === 0) {
                this.slideTo(sefl.eventList.length - 4, 0 ,false);
              }
              if (this.realIndex === sefl.eventList.length - 3) {
                this.slideTo(1, 0 ,false);
              }
            },
            observerUpdate: function () {
              Common.setKeepRatio();
            }
          }
        });
        eventSlide.slideTo(1, 0, false);

        var positionY = sessionStorage.getItem("positionY");
        scrollTo(0, positionY);
        setTimeout(function () {
          scrollTo(0, positionY);
        }, 100);
      });
      setTimeout(async () => {
        // ローカルキャッシュ作成
        const userId = this.$store.state.userId;
        getServerAllEvents();
      }, 100);
    },
    async getDataShop() {
      this.shopNews = await this.getSCNews(this.SHOP_ID, 3);
    },
    async getDataNews() {
      const result = await getLocalNewsListOfAllProvider();
      if (result) {
        this.newsList = this.makeSlideData(result.slice(0, this.newsSize));
      }
      setTimeout(async () => {
        const result = await getServerNewsListOfAllProvider();
        if (result) {
          this.newsList = this.makeSlideData(result.slice(0, this.newsSize));
        }
      });
    },
    async getDataEvent() {
      const result = await getLocalAllEvents();
      if (result) {
        this.eventList = this.makeSlideData(result.slice(0, this.newsSize));
      }
      setTimeout(async () => {
        const result = await getServerAllEvents();
        if (result) {
          this.eventList = this.makeSlideData(result.slice(0, this.newsSize));
        }
      });
    },
    makeSlideData(data) {
      if (data.length > 2) {
        return [
          data[data.length - 1],
          ...data,
          data[0],
          data[1],
          data[1],
        ]
      }
      return data;
    },
    openModalDetail(event) {
      this.eventId = event.id;
      this.eventProviderId = event.provider && event.provider.id;
      this.openModal = true;
      this.$router.push({ query: { eventId: event.id } });
    },
    openModalNewsDetail(news) {
      this.newsId = news.id;
      this.openModalNew = true;
      this.newsProviderId = news.provider && news.provider.id;
      this.$router.push({ query: { newsId: news.id } });
    },
    openBannerLink(url) {
      if (!url) return;
      Common.messageHandlers('show_browser', { url: url });
    },
    openMainBannerLink(banner) {
      if (!banner.url || !banner.typeUrl) return;
      if (banner.typeUrl === "external") {
        Common.messageHandlers('show_browser', { url: banner.url });
      } else {
        const bannerUrl = banner.typeUrl === "list" ? banner.url : banner.url + "&from=top";
        this.$router.push(bannerUrl);
      }
    },
    toggleFavoriteNews(news) {
      if (this.favoriteNewsExists(news.id)) {
        this.deleteFavorite(news, NEW_COLLECTION_KEY, news.provider);
      } else {
        this.addFavorite(news, NEW_COLLECTION_KEY, news.provider);
      }
    },
    toggleFavoriteEvent(event) {
      if (this.favoriteEventExists(event.id)) {
        this.deleteFavorite(event, EVENT_COLLECTION_KEY, event.provider);
      } else {
        this.addFavorite(event, EVENT_COLLECTION_KEY, event.provider);
      }
    },
  },
});
</script>
